import React, {Fragment, useCallback, useContext} from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {useDropzone} from "react-dropzone";

import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";

import LookAiPopupContext from "./LookAiPopupContext";
import {setAiUserFileBlobUrl} from "../../aiActions";
import LookAIPopupDropZoneError from "./LookAIPopupDropZoneError";
import PRLoader from "../../../ui/prLoader";
import LookAILoadingBar from "../lookAIOverlays/LookAILoadingBar";


const LookAIPopupDropZone = (props) => {

  const {aiLoading, setAiUserFileBlobUrl, aiResults, isMobile} = props;

  const {lookAiPopupContext, lookAiPopupDispatch} = useContext(LookAiPopupContext);
  const {userFileBlobUrl} = lookAiPopupContext;

  const onDrop = useCallback(acceptedFiles => {
    if (!acceptedFiles || !acceptedFiles[0]) {
      return
    }
    const userFileBlobUrl = URL.createObjectURL(acceptedFiles[0]);
    lookAiPopupDispatch({
      userFile: acceptedFiles[0],
      userFileBlobUrl,
    });
    setAiUserFileBlobUrl(userFileBlobUrl);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookAiPopupDispatch]);

  const activeResult = aiResults.find(aiResult => aiResult.isActive);
  const activeResultHasError = activeResult && activeResult.conversionError;
  const activeResultHasImage = activeResult && activeResult.resultImageUrl;

  const dropZoneDisabled = aiLoading || activeResultHasError;

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop,
    disabled: dropZoneDisabled,
    multiple: false,
    accept: {
      'image/*': [],
    }
  });

  return (
    <div
      {...getRootProps()}
      style={userFileBlobUrl && !aiLoading && !activeResultHasError ? {backgroundImage: `url(${userFileBlobUrl})`} : null}
      className={"overflow-hidden look-ai__sidebar-content relative look-ai__sidebar-content--dropzone rounded-05 pr-1 pl-1 bg-cover bg-center bg-no-repeat"
        + (dropZoneDisabled ? "" : " cursor-pointer")} >
      <input {...getInputProps()} />
      {aiLoading ? (
        <Fragment>
          <div
            className="absolute look-ai__dropzone-blur left-0 top-0 w-full h-full bg-cover bg-center bg-no-repeat rounded-05"
            style={{backgroundImage: `url(${userFileBlobUrl})`}}></div>
          <div className="flex flex--center flex--column h-full relative text-center w-full">
            <PRLoader/>
            <div className="look-ai__dropzone-text leading-1 bold w-full">
              <LookAILoadingBar/>
            </div>
          </div>
        </Fragment>
      ) : activeResultHasError ? (
        <LookAIPopupDropZoneError/>
      ) : userFileBlobUrl && !activeResultHasImage ? null : (
        <div className="flex flex--column flex--center w-full h-full">
          <div className={"absolute test-1 left-1/2 nowrap p-1 rounded-05 top-1/2 look-ai__upload"
            + (activeResultHasImage ? " look-ai__upload--with-image" : "")}>
            <div className="look-ai__title leading-1 bold flex flex--center gap-025">
              <CreateNewFolderOutlinedIcon/>
              <span><FormattedMessage id="look.ai.sidebar.title"/></span>
            </div>
            <span className="look-ai__text leading-1">
              <FormattedMessage id={isDragActive
                ? "look.ai.panel.dropActive"
                : isMobile ? "look.ai.sidebar.mobile.text" : "look.ai.sidebar.text"}/>
            </span>
          </div>
        </div>
      )}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {aiLoading, aiResults} = store.aiState;
  const {isMobile} = store.serverState;

  return {
    aiLoading,
    aiResults,
    isMobile,
  };
};

const mapDispatchToProps = {
  setAiUserFileBlobUrl,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(LookAIPopupDropZone)
)
